import { Component, OnInit } from '@angular/core';
import { DcBaseComponent } from '@datachain/ui-sdk/common';
import { debounceTime, fromEvent, takeUntil, tap } from 'rxjs';

import { ResizeProvider } from './resize-provider';

@Component({
	selector: 'app-resize-wrapper',
	template: `
		<ng-content></ng-content>
	`,
})
export class AppResizeWrapperComponent
	extends DcBaseComponent
	implements OnInit
{
	public constructor(private readonly provider: ResizeProvider) {
		super();
	}

	public ngOnInit(): void {
		super.ngOnInit();

		fromEvent(window, 'resize')
			.pipe(
				debounceTime(150),
				takeUntil(this.onDestroy$),
				tap(() => {
					this.provider.data$.next();
				})
			)
			.subscribe();
	}
}
